<template lang="pug">
v-card.mb-5(outlined)
  v-card-title Активные дни недели:
    timer
  v-card-text
    v-btn.pointer.mr-2.white--text.rounded(
      v-for="(day, index) in SHORT_DAYS" :key="day"
      :color="days.find(({day}) => day === index) ? 'success' : 'error'"
      :outlined="selectedDayIndex === index"
      rounded
      fab
      @click="selectedDayIndex = index"
    ) {{ day }}
    v-expand-transition
      div(v-if="selectedDayIndex !== null" :key="selectedDayIndex")
        v-overlay(:value="loading")
          v-progress-circular(indeterminate)
        .my-1.span.caption.grey--text.text--darken-1.
          * Время начала приема заявок
        time-picker(
          v-model="selectedDay.start_at"
          label="Время начала"
          filled
        )
        .mb-1.span.caption.grey--text.text--darken-1.
          * Время окончания приема заявок
        time-picker(
          v-model="selectedDay.end_at"
          label="Время окончания"
          filled
        )
        div
          template(v-if="selectedDay.id")
            v-btn(:disabled="!isValidForm" @click="updateDay" color="success").mr-2 Обновить
            v-btn( @click="deleteDay" color="error").mr-2 Удалить

          v-btn(:disabled="!isValidForm" @click="saveDay" v-else color="primary").mr-2 Сохранить
          v-btn(text @click="selectedDayIndex = null" ) Отменить
</template>
<script>
import TimePicker from '@/components/TimePicker.vue';
import Timer from './Timer.vue';
import { SHORT_DAYS } from '@/constants';
import { CRUDSchedule } from '@/services/API/_crud';
import { mapGetters } from 'vuex';

export default {
  components:{
    Timer,
    TimePicker,
  },
  data() {
    return {
      days: [],
      selectedDay: null,
      selectedDayIndex:null,
      loading: false,

      SHORT_DAYS,
    };
  },
  computed:{
    ...mapGetters({
      'user':'auth/getUser',
    }),
    isValidForm() {
      return this.selectedDay.start_at < this.selectedDay.end_at;
    },
  },
  watch:{
    selectedDayIndex() {
      this.selectedDay =  this.days.find(({ day }) => day === this.selectedDayIndex) || {
        start_at: '09:00',
        end_at: '16:00',
      };
    },
  },
  async created() {
    const params = {
      'search[region_id]': this.user.region_id,
    };
    const response = await CRUDSchedule.getAll(params);
    this.days = response.data.data;
  },
  methods:{
    async updateDay() {
      this.loading = true;

      try {
        const response = await CRUDSchedule.update(this.selectedDay.id, this.selectedDay);

        const days = [...this.days];
        const index = days.findIndex(({ id }) => id === this.selectedDay.id);
        days[index] = response.data.data;
        this.days  = days;

        this.$toast.success('Расписание было обновлено');
      } catch (error) {
        this.$toast.error('Не удолось обновить');
      } finally {
        this.loading = false;
        this.selectedDayIndex  = null;
      }
    },

    async deleteDay() {
      this.loading = true;

      await CRUDSchedule.delete(this.selectedDay.id);
      this.days = this.days.filter(({ id }) => id !== this.selectedDay.id);

      this.loading = false;
      this.selectedDayIndex  = null;

      this.$toast.success('День был удален');
    },

    async saveDay() {
      this.loading = true;
      const params = {
        ...this.selectedDay,
        day: this.selectedDayIndex,
        region_id: this.user.region_id,
      };
      const response = await CRUDSchedule.create(params);
      this.days.push(response.data.data);

      this.loading = false;
      this.selectedDayIndex  = null;

      this.$toast.success('День был сохранен');
    },
  },
};
</script>

<style>

</style>
